
import { graphql } from 'gatsby';
import PropTypes, { any } from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import '@src/components/layout/banner.scss';
import Layout from '@src/components/layout/layout';
import pageSlugs from '@src/components/layout/pageSlugs';
import HomePage from '@src/components/pages/homePage/homePage';
import {
  filterLocaleNodes,
  filterLocaleNodesSubjects,
} from '@src/i18n/localeList';

export const query = graphql`
  query {
    allContentfulHomepage {
      nodes {
        ...HomepageInfo
      }
    }
    allContentfulMokomasisDalykas(sort: { name: ASC }) {
      nodes {
        ...SubjectsInfo
      }
    }
  }
`;

const locale = 'en';

const RootIndex = ({ data }) => {
  const { i18n } = useTranslation();

  const otherSlugs = Object.keys(pageSlugs.homePage).map((key) => {
    return {
      locale: key,
      slug: pageSlugs.homePage[key],
    };
  });

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, []);

  const pageData = filterLocaleNodes(
    data.allContentfulHomepage.nodes,
    locale
  )[0];

  const subjectsData = filterLocaleNodesSubjects(
    data.allContentfulMokomasisDalykas.nodes,
    locale
  );

  return (
    <Layout
      locale={locale}
      otherSlugs={otherSlugs}
      currentSlug={pageSlugs.homePage[locale]}
    >
      <HomePage pageData={pageData} subjectsData={subjectsData} />
    </Layout>
  );
};

RootIndex.propTypes = {
  data: PropTypes.shape({
    allContentfulHomepage: PropTypes.shape({
      nodes: any,
    }),
    allContentfulMokomasisDalykas: PropTypes.shape({
      nodes: any,
    }),
  }),
};

export default RootIndex;
